/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
// import {OPKey} from '../../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
// import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const capitalGoodsJSON = async (): Promise<any> => {
  const capitalGoods = useJSONStore.getState().capitalGoods;
  const token = useUserStore.getState().userToken;
  const setCapitalGoods = useJSONStore.getState().setCapitalGoods;
  // const companyDetails = useCompanyStore.getState().companyDetails;

  if (capitalGoods.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.capitalGoods}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setCapitalGoods(res?.data?.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default capitalGoodsJSON;
